import React from "react"
import styles from "./styles"

const ClientPrivacyPolicy = () => {
  const classes = styles()
  return <div>Client Privacy Policy - Content Pending</div>
}

export default ClientPrivacyPolicy
